export var FIRST_ORDER_INCENTIVE_MODAL_DISMISS = 'FIRST_ORDER_INCENTIVE_MODAL_DISMISS';
